import { render, staticRenderFns } from "./VerNumerosVendidos2.vue?vue&type=template&id=6a120c80"
import script from "./VerNumerosVendidos2.vue?vue&type=script&lang=js"
export * from "./VerNumerosVendidos2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports